import React, { useMemo, useState } from "react";
import { FiEdit3 } from "react-icons/fi";
import PrimaryButton from "../../../../../components/PrimaryButton";
import SectionHeading from "../../../../../components/SectionHeading";
import { Box, Button, Heading } from "@chakra-ui/react";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  getAxiosConfig,
  getGoogleImageUrl,
  getMinioImage,
} from "../../../../../utils/helpers";
import Img from "../../../../../components/Img";
import Placeholder from "../../../../../assets/placeholder-600x400.webp";
import CarasouelImages from "../../../../../components/CarasouelImages";
import { Icon } from "@iconify/react/dist/iconify.js";
import { toast } from "react-toastify";
import axios from "axios";
import moment from "moment";

const SingleCard = ({
  images = [],
  label,
  data,
  handleEdit,
  activeTabIdx,
  isRandom,
  randomImages,
  fetchPresentationData,
  handlePublicLink,
  // onClickDuplicate,
  duplicatePresentation,
  allVersions = [],
}) => {
  // console.log({ random});
  const nav = useNavigate();
  const { projectData } = useOutletContext() || { projectData: { Images: [] } };
  const [isHover, setIsHover] = useState(false);
  const IS_SITE = activeTabIdx == 0;
  let Images = [];
  if (!isRandom) {
    [...Array(4)].forEach((_, i) => {
      Images.push(
        projectData?.projectImages[
          Math.floor(Math.random() * projectData?.projectImages?.length)
        ],
      );
    });
  }
  let pills = [];
  if (activeTabIdx == 0) {
    pills.push({ label: "Client logo", value: "Uploaded" });
    pills.push({ label: "Section", value: data.buildingData?.length || 0 });
    pills.push({ label: "Site image", value: "Uploaded" });
  } else {
    pills.push({ label: "Company logo", value: "Uploaded" });
    pills.push({ label: "Areas", value: data?.areas?.length || 0 });
    pills.push({ label: "Floor map", value: "Uploaded" });
  }
  Images = useMemo(() => {
    return Images.map((img) => getMinioImage(img));
  }, [Images]);
  console.log("SINGLE CARD IMAGES", Images);
  let randomImage = useMemo(() => {
    return isRandom
      ? randomImages?.length > 0
        ? randomImages[Math.floor(Math.random() * randomImages.length)]
        : Placeholder
      : Images?.length > 0
        ? Images[Math.floor(Math.random() * Images.length)]
        : Placeholder;
  }, []); // console.log(Images,projectData.projectImages,  "IMAGES IN SINGLE CARD");
  const deletePresentation = async (id) => {
    // console.log(activeTabIdx, fetchPresentationData);
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this presentation?",
    );

    if (!isConfirmed) return;
    try {
      await axios.delete(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/${id}`,

        getAxiosConfig({
          type:
            activeTabIdx == 0
              ? "site"
              : activeTabIdx == 1
                ? "moodboard"
                : "render",
        }),
      );
      fetchPresentationData && fetchPresentationData(id);
      toast.success("Presentation deleted successfully");
    } catch (error) {
      console.error("Error deleting presentation:", error);
      toast.error("Failed to delete presentation. Please try again.");
    }
  };
  console.log(
    { createdAt: data?.createdAt },
    moment(data?.createdAt).format("DD"),
    data,
  );
  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      // onClick={() =>
      //   nav(
      //     `/publicView/${
      //       activeTabIdx == 0
      //         ? "site"
      //         : activeTabIdx == 1
      //         ? "conceptual"
      //         : "render"
      //     }/${data?._id}/${isRandom ? data?.companyName : projectData?.title}`,
      //     { state: { data } }
      //   )
      // }
      className=" max-h-[500px]  min-h-[280px] relative w-full rounded-md overflow-hidden cursor-pointer "
    >
      {/* <CarasouelImages
          images={randomImages}
        /> */}
      {
        <Img
          src={activeTabIdx != 0 ? randomImage : getGoogleImageUrl(randomImage)}
          alt="Random Image"
          height="100% "
          width="100%"
          className={
            "w-full h-full object-cover rounded-md hover:scale-105 transition-transform duration-300 ease-in-out"
          }
        />
      }
      {/* {activeTabIdx ==0 && <iframe 
      
      src={getGoogleImageUrl( randomImage)}
      className="w-full h-full"

      />} */}

      <div className="flex justify-between items-start  w-full p-2 absolute bottom-0 left-0 bg-black/20 backdrop-blur-sm z-[9]">
        <div>
          <Heading size={"md"} className="text-white flex items-center gap-2">
            {data?.companyName}
            {allVersions.length > 1 ? (
              <span className="text-xs bg-teal-600 text-white px-2 py-0.5 rounded-full font-medium">
                {allVersions.length} versions
              </span>
            ) : data?.version && data.version > 1 ? (
              <span className="text-sm bg-teal-600 text-white px-2 py-0.5 rounded-full">
                v{data.version}
              </span>
            ) : null}
          </Heading>
          {/* {isRandom && ( */}
          <p className="text-xs text-gray-100 ">
            Created By : {data?.username} on{" "}
            {moment(data?.createdAt).format("DD MMM YYYY ")}
            {/* {data?.createdAt?.split("T")?.[0]?.split("-")?.reverse()?.join("-")} */}
          </p>
          {/* )} */}
        </div>
        {!IS_SITE && (
          <div
            //  style={{
            // zIndex: "50 !important"
            // }}
            className="text-teal-400 text-xl cursor-pointer hover:bg-teal-700/40 rounded-full p-2  "
            onClick={(e) => {
              e.stopPropagation();
              handleEdit(data?._id);
            }}
          >
            <FiEdit3 />
          </div>
        )}
      </div>
      {
        <div
          //  style={{
          // zIndex: "50 !important"
          // }}
          className="text-red-500 text-xl cursor-pointer bg-black/50 hover:bg-red-700/40 rounded-full p-2 absolute top-1 right-1 z-[9] "
          onClick={(e) => {
            e.stopPropagation();
            deletePresentation(data?._id);
          }}
        >
          <Icon icon={"fluent:delete-16-filled"} color="red" width={"20px"} />
        </div>
      }
      {
        <div
          className="text-teal-400 text-xl cursor-pointer bg-black/50 hover:bg-teal-700/40 rounded-full p-2 absolute top-1 right-12 z-[9] "
          onClick={(e) => {
            e.stopPropagation();
            const type =
              activeTabIdx === 0
                ? "feasibility"
                : activeTabIdx === 1
                  ? "concept"
                  : "render";
            duplicatePresentation && duplicatePresentation(data?._id, type);
          }}
        >
          <Icon icon={"fluent:copy-16-filled"} color="#2dd4bf" width={"20px"} />
        </div>
      }
      {isHover && (
        <div className="absolute top-0 left-0 w-full h-full bg-black/40 flex items-center justify-center gap-4">
          <Button
            onClick={() =>
              nav(
                `/pv/${
                  activeTabIdx == 0
                    ? "site"
                    : activeTabIdx == 1
                      ? "conceptual"
                      : "render"
                }/${data?._id}/${data?.companyName}?type=internal`,
                { state: { data } },
              )
            }
            size={"sm"}
            className="px-2 py-1.5 bg-black text-gray-300"
          >
            Internal View
          </Button>
          <Button onClick={handlePublicLink} colorScheme="teal" size={"sm"}>
            Client View
          </Button>
        </div>
      )}
    </div>
  );
};

export default SingleCard;
